// istanbul ignore file
import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type DonutKpiDataObject, type DonutKpiState } from '../types'

const initialState: DonutKpiState = {
  isLoading: true,
  error: false,
  data: undefined,
  httpStatus: 0
}

const historyDonutSlice = createSlice({
  name: 'historyDonut',
  initialState,
  reducers: {
    historyDonutLoadingAction: (state) => {
      return {
        isLoading: true,
        error: false,
        data: undefined,
        httpStatus: 0
      }
    },
    historyDonutUpdateAction: (state, action: PayloadAction<{ data: DonutKpiDataObject, httpStatus: number }>) => {
      return {
        isLoading: false,
        error: false,
        data: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    },
    historyDonutErrorAction: (state, action: PayloadAction<number>) => {
      return {
        isLoading: false,
        error: true,
        data: undefined,
        httpStatus: action.payload
      }
    },
    historyDonutResetAction: () => {
      return initialState
    }
  }
})

export const {
  historyDonutLoadingAction,
  historyDonutUpdateAction,
  historyDonutErrorAction,
  historyDonutResetAction
} = historyDonutSlice.actions

export default historyDonutSlice.reducer
